import { boxIntRange } from '../../../CodesThatsGottaGoSomewhereElse';
import { ObjectUpdate } from '../../../concepts/objects';
import { FontSizeIntervals } from '../../../platform/assets/FontFamilyInfo';
import { Point } from '../../../platform/geom/Point';
import { CreatePhysicalToolBehavior, CreateTransformableDragParams } from '../../canvas/tooling/CreatePhysicalToolBehavior';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { Colors } from './../../../ui';
import { Text } from './Text';

class CreateTextToolBehavior extends CreatePhysicalToolBehavior(Text, 'drag:edit') {

    protected createSubject(u: ObjectUpdate) {
        const text = super.createSubject(u);
        text.fontSize = boxIntRange(Math.round(30 / this.camera.scale), FontSizeIntervals.map(x => x.value));
        text.fontColor = this.settings.color ?? Colors.text;
        text.fontFamily = this.settings.fontName ?? 'Inter';
        if (this.mode === 'drop') {
            text.content = 'Text';
        }
        return text;
    }

    protected applyPlop(subject: Text, vpt: Point): void {
        super.applyPlop(subject, vpt);
        subject.autoWidth = true;
        subject.autoHeight = true;
    }

    protected applyDrag(subject: Text, drag: CreateTransformableDragParams): void {
        super.applyDrag(subject, drag);
        const { width, height } = drag.rect(this.grid);
        const auto = width < subject.minWidth && height < subject.minHeight;
        subject.autoWidth = auto;
        subject.autoHeight = auto;
    }
}

export const textTool = defineToolWithCommonBehaviors({
    id: 'textTool',
    label: 'Text',
    category: 'design',
    icon: 'deqo://icons/d2/text',
    weight: 3020,
    shortcut: 'T',
    behaviors: [CreateTextToolBehavior]
});
